import styled from "styled-components";
import { colorPallet } from "../../../styles/global";

export const ButtonLink = styled.button`
  color: ${colorPallet.darkBlue};
  border: none;
  background: transparent;
  font-weight: normal;
  font-size: 20px;
  text-decoration: none;
  margin-bottom: 0.5rem;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "all")};
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  &:hover {
    color: #df8c07;
    transform: scale(1.2);
    transition: all 0.3s ease-out;
  }
  @media screen and (max-width: 768) {
    font-weight: 400;
  }
`;
